import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface AddStepModalProps {
  open: boolean;
  initialValue: string;
  onClose: () => void;
  onSubmit: (inputValue: string) => void;
}

export default function AddStepModal({ open, initialValue, onClose, onSubmit }: AddStepModalProps) {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    if (open) {
      setInputValue(initialValue);
    }
  }, [open, initialValue]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialValue ? 'Edit Step' : 'Add Step'}</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="Step Name" fullWidth value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onSubmit(inputValue)} disabled={!inputValue.trim()}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
